import { render, staticRenderFns } from "./SelectColumnsEnhanceAccountMachineLearning.vue?vue&type=template&id=af1a7684&scoped=true"
import script from "./SelectColumnsEnhanceAccountMachineLearning.vue?vue&type=script&lang=js"
export * from "./SelectColumnsEnhanceAccountMachineLearning.vue?vue&type=script&lang=js"
import style0 from "./SelectColumnsEnhanceAccountMachineLearning.vue?vue&type=style&index=0&id=af1a7684&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af1a7684",
  null
  
)

export default component.exports